import { ProfileOutlined } from '@ant-design/icons';
import { selectedTagStyle } from '@components';
import { useServiceTemplateOptions } from '@hooks';
import { L } from '@lib';
import { Select, Tag } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

interface IProps {
  value?: number[];
  onChange?: (value: number[]) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  loading?: boolean;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  maxTagCount?: number | 'responsive';
}

/** Assigns a service to templates - the reverse of picking services inside a template. */
export const ServiceTemplateSelect: React.FC<IProps> = observer(
  ({
    value,
    onChange,
    placeholder,
    allowClear = true,
    disabled = false,
    loading = false,
    size,
    style,
    maxTagCount = 'responsive',
  }) => {
    const { options, loading: optionsLoading } = useServiceTemplateOptions();
    const isLoading = loading || optionsLoading;

    return (
      <Select
        mode="multiple"
        showSearch
        optionFilterProp="label"
        loading={isLoading}
        disabled={disabled}
        allowClear={allowClear}
        maxTagCount={maxTagCount}
        notFoundContent={isLoading ? null : L('No templates yet')}
        style={{ width: '100%', ...style }}
        size={size}
        value={value}
        options={options}
        onChange={(next: number[]) => onChange?.(next ?? [])}
        placeholder={placeholder || L('Assign to templates')}
        tagRender={({ label, closable, onClose }) => (
          <Tag
            icon={<ProfileOutlined />}
            closable={closable}
            onClose={onClose}
            // Keeps a click on the tag from toggling the dropdown open.
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            style={{ ...selectedTagStyle, margin: '2px 4px 2px 0' }}
          >
            {label}
          </Tag>
        )}
      />
    );
  }
);
